<template>
  <div
    v-if="datas && datas.length"
    class="margin-vertical-5"
    :class="{ 'section-loading': isLoading }"
  >
    <div class="box" :class="className.sectionBlock"></div>
    <span class="font-20">
      <strong>{{ title }}</strong>
      <a
        @click="detailToggle(isShow)"
        role="button"
        class="btn btn-icon btn-sm btn-collapse mt-0"
        :class="isShow ? 'btn-primary' : 'btn-default'"
      >
        <i :class="isShow ? 'icon-collapse_up' : 'icon-collapse_down'"></i>
      </a>
    </span>
    <section v-if="isShow" class="newTable mb-5">
      <slot
        :theme="theme"
        :datas="datas"
        :_fields="_fields"
        :constantSortKey="constantSortKey"
        :constantSortType="constantSortType"
        :initSort="initSort"
      ></slot>
    </section>
  </div>
</template>

<script>
import HardwordMixins from "@/mixins/Hardword";

export default {
  mixins: [HardwordMixins],
  props: {
    title: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      required: true
    },
    datas: {
      type: Array,
      required: true
    },
    _fields: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    constantSortKey: Array,
    constantSortType: Array,
    initSort: Object,
    initShow: { type: Boolean, default: true }
  },
  hardwroldWatcher: ["datas"],
  data() {
    return { isShow: this.initShow };
  },
  methods: {
    detailToggle(val) {
      this.isShow = !val;
      this.$emit("toggle", this.isShow);
    }
  },
  computed: {
    className() {
      switch (this.theme) {
        case "red":
          return {
            sectionBlock: "boxRed"
          };
        case "blue":
          return {
            sectionBlock: "boxBlue"
          };
        case "green":
          return {
            sectionBlock: "boxGreen"
          };
      }
    }
  }
};
</script>

<style scoped>
.box {
  float: left;
  height: 24px;
  width: 8px;
  margin-right: 8px;
  clear: both;
}
.boxGreen {
  background-color: #027a39;
}
.boxBlue {
  background-color: #007ab1;
}
.boxRed {
  background-color: #de4054;
}
</style>
